import { IdNameObject } from '@m/types';
import { apiFetch } from '@m/utils/http';
import { createEffect } from 'effector';

export const fetchEnums = createEffect({
  handler: ({ isAdmin }: { isAdmin: boolean }) => apiFetch(isAdmin ? '/admin/enums' : '/enums'),
});

export const fetchLPStates = createEffect({
  handler: () => apiFetch<IdNameObject[]>('/enums/license-plate-states'),
});

export const fetchInvoiceLineItemProductTypes = createEffect({
  handler: () => apiFetch('/v2/finance-operations/invoices/product-types'),
});

export const fetchInvoiceLineItemValidationTypeIds = ({ entId }: { entId: string }) =>
  apiFetch(`/admin/enterprise/${entId}/location-sign-list`);

// TODO: we will add this data to response of /enum
export const fetchOperator = createEffect({
  handler: () => apiFetch('/v2/operator'),
});

export const fetchSubscriptionCancellationReasons = createEffect({
  handler: () => apiFetch('/admin/subscription/cancellation-reasons'),
});
